<a class="learning-card" [routerLink]="['/learning', learning.id]">
  @if (learning.isFavorite) {
    <div class="bookmark-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z" />
      </svg>
    </div>
  }

  @if (isAdmin) {
    <div class="status-indicator" [class.active]="learning.active" [class.inactive]="!learning.active">
      @if (learning.active) {
        <svg width="18" height="18" viewBox="0 0 35 35">
          <g transform="translate(-618.181 -467.681)">
            <g transform="translate(618.181 467.681)">
              <path
                d="M3454.125,1371.9a17.5,17.5,0,1,1,17.5-17.5A17.52,17.52,0,0,1,3454.125,1371.9Z"
                transform="translate(-3436.625 -1336.902)"
                fill="#00a5a9"
                />
            </g>
            <g transform="translate(626.654 479.133)">
              <path
                d="M3486.832,1406.667l-7.537-7.537,1.58-1.58,5.958,5.958,8.936-8.936,1.58,1.58Z"
                transform="translate(-3479.295 -1394.572)"
                fill="#fff"
                />
            </g>
          </g>
        </svg>
      }
      @if (!learning.active) {
        <svg width="18" height="18" viewBox="0 0 35 35">
          <g transform="translate(-354 -331)">
            <g transform="translate(354 331)">
              <path
                d="M3454.125,1371.9a17.5,17.5,0,1,1,17.5-17.5A17.52,17.52,0,0,1,3454.125,1371.9Z"
                transform="translate(-3436.625 -1336.902)"
                fill="#e30714"
                />
            </g>
            <g transform="translate(366.603 343.6)">
              <g transform="translate(0 0)">
                <rect width="12.872" height="1.934" transform="translate(0 9.102) rotate(-45)" fill="#fff" />
              </g>
              <g transform="translate(0 0)">
                <rect width="1.934" height="12.872" transform="translate(0 1.367) rotate(-45)" fill="#fff" />
              </g>
            </g>
          </g>
        </svg>
      }
      <span class="status-text">{{
        learning.active ? ('LEARNING.ACTIVE' | translate) : ('LEARNING.INACTIVE' | translate)
      }}</span>
    </div>
  }

  <div class="card-image">
    @if (!imageLoaded) {
      <div class="image-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      </div>
    }

    @if (imageUrl) {
      <img
        [src]="imageUrl"
        [alt]="learning.title"
        class="w-100"
        (load)="onImageLoad()"
        (error)="onImageError()"
        />
    }
  </div>

  <div class="card-content">
    <div class="complexity-indicator d-flex align-items-center gap-1">
      <span class="complexity-label">{{ 'LEARNING.COMPLEXITY' | translate }}</span>
      <div class="complexity-dots d-flex gap-1">
        @for (dot of getComplexityArray(); track dot) {
          <span class="complexity-dot" [class.active]="dot === 1"></span>
        }
      </div>
    </div>

    <h5 class="card-title">{{ learning.title }}</h5>

    @if (learning.machineTypes && learning.machineTypes.length > 0) {
      <div class="card-footer">
        <span class="machine-type">{{ learning.machineTypes.join(', ') }}</span>
      </div>
    }

    @if (learning.tags && learning.tags.length > 0) {
      <div class="card-tags">
        <span class="tags-list">{{ getFormattedTags() }}</span>
      </div>
    }
  </div>
</a>
